import React from "react";
import { zipSync } from "fflate";

import { useRecoilValue, useRecoilValueLoadable } from "recoil";
import {
  asyncGetAspectList,
  asyncGetThreadList,
  getWordsList,
} from "lib/store/dashboard";
import { asyncGetProject, currentProject } from "lib/store/project";
import { dateState } from "lib/store/common";

import { Modal } from "@atsent/components";

import "./ExportModal.scss";

export type ExportModalProps = {
  cx?: string;
  close: unknown;
};

const imageF = process.env.PUBLIC_URL + "/static-image";

export const ExportModal: React.FC<ExportModalProps> = ({ cx = "", close }) => {
  const asyncThread = useRecoilValueLoadable(asyncGetThreadList(1));
  const asyncAspect = useRecoilValueLoadable(asyncGetAspectList);
  const project = useRecoilValueLoadable(asyncGetProject);
  const pid = useRecoilValue(currentProject);
  const { range } = useRecoilValue(dateState);
  const thread = async () => {
    const returnVal = await getWordsList(pid, {
      size: asyncThread.contents.count,
      start: range.first.format("YYYY-MM-DD"),
      end: range.last.format("YYYY-MM-DD"),
    });
    return returnVal.results.reduce((accm: string, curr: any, idx: number) => {
      return `${accm}${idx + 1},"${curr.plain_text.replaceAll('"', "\\'")}",${
        curr.result?.aspect
      },${curr.result?.aspect_score},${curr.result?.sentiment},${
        curr.result?.sentiment_score
      }\n`;
    }, "id,text,aspect,aspect_score,sentiment,sentiment_score\n");
  };

  const aspect = async () =>
    asyncAspect.contents.reduce((accm: string, curr: any, idx: number) => {
      return `${accm}${idx + 1},"${curr.aspect}",${curr.positive},${
        curr.neutral
      },${curr.negative}\n`;
    }, "id,aspect,positive,neutral,negative\n");

  return (
    <Modal cx={`ExportModal ${cx}`} title={"내보내기"} close={close}>
      <div
        className={"csv"}
        onClick={async () => {
          const data = await thread();
          const data2 = await aspect();

          const blob = new Blob([data], {
            type: "text/csv",
          });
          const blob2 = new Blob([data2], {
            type: "text/csv",
          });

          const zip = zipSync(
            {
              "thread.csv": new Uint8Array(await blob.arrayBuffer()),
              "aspect.csv": new Uint8Array(await blob2.arrayBuffer()),
            },
            { level: 0 }
          );

          const a = document.createElement("a");
          a.href = window.URL.createObjectURL(new Blob([zip]));
          a.download = `${project.contents?.name}-${range.first}-${range.last}.zip`;
          a.click();
          a.remove();
        }}
      >
        <img src={`${imageF}/export_csv_icon.png`} alt={"svg"} />
        <span>CSV</span>
      </div>
      <div className={"slack"}>
        <img src={`${imageF}/slack-disable.png`} alt={"slack"} />
        <span>Slack</span>
      </div>
      <div className={"email"}>
        <img src={`${imageF}/export_email_icon_disabled.png`} alt={"email"} />
        <span>Email</span>
      </div>
      <div className={"api"}>
        <img src={`${imageF}/export_api_icon_disabled.png`} alt={"api"} />
        <span>API</span>
      </div>
    </Modal>
  );
};
